export const ListQueryKey = 'activitySubAuths';
export const DetailQueryKey = 'activitySubAuth';
export const Urls = {
  selectUrl: '/subAuthConfig/list',
  updateUrl: '/subAuthConfig/update',
  deleteUrl: '/subAuthConfig/delete',
  createUrl: '/subAuthConfig/create',
  detailUrl: '/subAuthConfig/detail'
};